import { Reveal } from "./Reveal";
import { images } from "./data";

const cards = [
  { title: "South Indian Breakfast", description: "Golden dosas, pillowy idlis, crisp vadas and brass-filter coffee", image: images.dosa, span: "sm:col-span-2 lg:col-span-2" },
  { title: "North Indian Cuisine", description: "Slow-cooked curries, butter chicken and blistered tandoori rotis", image: images.butterChicken, span: "" },
  { title: "All-Day Breakfast", description: "Royal platters, club sandwiches and cheese omelettes till late", image: images.breakfastPlatter, span: "" },
  { title: "Continental & Cafe Classics", description: "Pancakes, poached eggs, burgers and fresh-pressed juices", image: images.royalBurger, span: "sm:col-span-2 lg:col-span-2" },
];

const tags = ["Indian Breakfast", "Lunch & Dinner", "Vegetarian Dishes", "Cafe-Style Breakfast", "Multi-Cuisine Food"];

export const Specialities = () => (
  <section id="specialities" className="relative bg-surface px-5 py-24 sm:px-8 sm:py-32" data-testid="specialities-section">
    <div className="mx-auto max-w-7xl">
      <Reveal className="mb-14 flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="eyebrow mb-5">02 · Our Specialities</p>
          <h2 className="font-display text-3xl leading-[1.2] tracking-tight text-cream sm:text-4xl">
            Four kitchens,
            <br />
            <span className="gold-text italic">one royal table.</span>
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-ash">
          From sunrise tiffins to late-evening curries — every plate leaves the pass fresh, generous and full of Goa.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((card, i) => (
          <Reveal key={card.title} delay={i * 0.1} className={card.span}>
            <article
              className="gold-ring-card group relative h-80 overflow-hidden rounded-2xl bg-coal sm:h-96"
              data-testid={`speciality-card-${i}`}
            >
              <img
                src={card.image}
                alt={card.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-onyx via-onyx/30 to-transparent" />
              <span className="absolute left-5 top-5 rounded-full border border-gold/30 bg-onyx/60 px-3 py-1 font-mono text-[0.6rem] uppercase tracking-[0.25em] text-gold-light backdrop-blur-md">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="absolute inset-x-0 bottom-0 p-6">
                <h3 className="font-display text-xl text-cream sm:text-2xl">{card.title}</h3>
                <p className="mt-2 max-w-xs text-xs leading-relaxed text-ash sm:text-sm">{card.description}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1} className="mt-10 flex flex-wrap items-center gap-3">
        <span className="font-mono text-[0.62rem] uppercase tracking-[0.25em] text-ash">Also on the table —</span>
        {tags.map((tag) => (
          <span key={tag} className="rounded-full border border-cream/15 px-4 py-1.5 text-xs text-cream/75 transition-colors duration-300 hover:border-gold/50 hover:text-gold-light">
            {tag}
          </span>
        ))}
      </Reveal>
    </div>
  </section>
);
